import PropTypes from 'prop-types';
import React from 'react';

import classNames from 'classnames';


class ProgressMarker extends React.Component {
  constructor(){
    super();
  }

  render() {
    let markY = this.props.size / 2;
    let markR = this.props.size / 2;
    let fontSize = markR * 1.25;
    let markX = this.props.size / 2;
    const cn = classNames({
      inactive: (!this.props.active)
    });

    return (
      <g className={cn} transform={`translate(${this.props.x},${this.props.y})`}>
        <circle
          cx={markX}
          cy={markY}
          r={markR}
          fill="red" />
        <text
          textAnchor="middle"
          x={markX}
          y={markY}
          dy={fontSize / 3}
          fontSize={fontSize}
          >{this.props.label}</text>
      </g>
    );
  }
}

ProgressMarker.propTypes = {
  x: PropTypes.number.isRequired,
  y: PropTypes.number.isRequired,
  size: PropTypes.number.isRequired,
  active: PropTypes.bool.isRequired,
  label: PropTypes.string.isRequired
};

export default class ProgressHeader extends React.Component {
  constructor(){
    super();
  }

  render() {
    let numMarkers = 5;
    let markerMaxWidth = (this.props.width) / numMarkers / 2;
    let markerSize = Math.min((this.props.height / 2), markerMaxWidth);
    let barHeight = markerSize / 3;
    let barTop = (this.props.height - barHeight) / 2;
    let markerTop = (this.props.height - markerSize) / 2;
    let totalMarkers = markerSize * this.props.totalStages;
    let totalPadding = this.props.width - totalMarkers;
    let stageWidth = markerSize + (totalPadding / (this.props.totalStages - 1));
    let markers = Array.from(Array(this.props.totalStages).keys()).map(stage => {
      return (
        <ProgressMarker
          key={stage}
          x={stageWidth * stage}
          active={stage < this.props.currentStage}
          size={markerSize}
          label={`${stage + 1}`}
          y={markerTop} />
      );
    });

    return (
      <svg className="progressHeader" height={this.props.height} width={this.props.width}>
        <rect className="bar" x={markerSize / 2} width={this.props.width - markerSize} height={barHeight} y={barTop} />
        <rect className="progress" x={markerSize / 2} width={stageWidth * (this.props.currentStage - 1)} height={barHeight} y={barTop} />
        {markers}
      </svg>
    );
  }
}

ProgressHeader.propTypes = {
  width: PropTypes.number.isRequired,
  height: PropTypes.number.isRequired,
  totalStages: PropTypes.number.isRequired,
  currentStage: PropTypes.number.isRequired
};
